// ===== Module features for easy import in ClientContainer =====

import InventoryContainer from './components/InventoryContainer';
import ProductionAnalyticsModule from './components/AnalyticsContainer';
import ProductionContainer from './components/ProductionContainer';
import ProductionPlanning from './ProductionPlanning';

const ProductionModule = {
  ProductionContainer,
  InventoryContainer,
  ...ProductionAnalyticsModule,
  ProductionPlanning,
};

export default ProductionModule;
